import React from "react";

/**
 * WILLIAMS Golf Therapy — Original brand logo
 * Embedded directly from the founder's official brand identity.
 * Classic circular badge with golfer silhouette, golf-ball texture, EST. 1994, gold rules.
 */
const Logo = ({ size = 88, variant = "dark" }) => {
  // variant="light" => used on dark green backgrounds (hero, nav, footer)
  // variant="dark"  => used on cream/light backgrounds
  const ringColor = variant === "light" ? "rgba(201,162,75,0.55)" : "rgba(11,61,46,0.18)";
  return (
    <div
      data-testid="wgt-logo"
      aria-label="WILLIAMS Golf Therapy logo"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        background: "#ffffff",
        boxShadow: `0 0 0 1px ${ringColor}, 0 6px 22px rgba(0,0,0,0.18)`,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src="/brand/wgt-logo.jpg"
        alt="WILLIAMS Golf Therapy"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          display: "block",
          padding: "0",
        }}
      />
    </div>
  );
};

export default Logo;
